export default __webpack_public_path__ + "images/0x8ad39144b37741573f85aa03d6c3e817a0054161.png";